import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import { HeaderBreadcrumb, SectionTitle } from '@components/ui';
import { DataTable } from '@components/ui/data.table/data-table';
import PaginationComponent from '@components/ui/pagination';

import { DEFAULT_PAGE_LIMIT, Route } from '@/constants';
import { useUrlPagination } from '@/hooks';
import { purchaseReturnListColumn } from '@/modules/purchase/purchase-return/purchase-return-list/purchase-return-list.column';
import { usePurchaseReturnList } from '@/modules/purchase/purchase-return/purchase-return-list/purchase-return-list.hook';

export const PurchaseReturnList = () => {
    const { page, setCurrentPage } = useUrlPagination();
    const { data, isLoading, isError, error } = usePurchaseReturnList();

    return (
        <SectionContainer
            fallbackPath={Route.DASHBOARD}
            isError={isError}
            isLoading={isLoading}
            error={error}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Purchases', href: Route.PURCHASES },
                                { label: 'Purchase Returns' },
                            ]}
                        />
                        <SectionTitle>Purchase Returns</SectionTitle>
                    </div>

                    <Link to={Route.PURCHASE_RETURN_CREATE}>
                        <Button type={'button'}>Add Purchase Return</Button>
                    </Link>
                </div>

                <Card className={''}>
                    <DataTable
                        data={data?.data ?? []}
                        columns={purchaseReturnListColumn}
                    />
                    <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                        Total Found : {data?.pagination?.total_items}
                    </p>
                    <PaginationComponent
                        totalItems={data?.pagination?.total_items ?? 0}
                        itemsPerPage={
                            data?.pagination?.limit ?? DEFAULT_PAGE_LIMIT
                        }
                        initialPage={page}
                        onPageChange={(p) => {
                            setCurrentPage(p);
                        }}
                    />
                </Card>
            </Card>
        </SectionContainer>
    );
};

PurchaseReturnList.displayName = 'PurchaseReturnList';
